<form [formGroup]="form">
    <!-- Edit Mode Table: viewMode >= 2 -->
    <table class="ham-table" *ngIf="viewMode >= 2">
        <!-- Header Row -->
        <thead>
            <tr formGroupName="headers">
                <th class="hamScaleCol" style="min-width: 400px">
                    <!-- ham-referencing-input-component in Edit Mode -->
                    <ham-referencing-input-component
                        class="referencing-input"
                        [isEditMode]="true"
                        [title]="form.get('headers.text')?.value"
                        [isReferenced]="addReferencing"
                        [isNumbered]="addNumbering"
                        [numbering]="tableNumber"
                        [width]="'400px'"
                        (titleChange)="onTitleChanged($event)"
                        (addNumbering)="onAddNumberToggleChange($event)"
                        (addReferencing)="openReferenceDialog()"
                    ></ham-referencing-input-component>
                </th>
                <th class="hamNumberCol300 currentYear">
                    <!-- Read-only header for current date -->
                    {{ form.get('headers.currentValue')?.value | dateLocale }}
                </th>
                <th class="hamNumberCol300 previousYear">
                    <!-- Read-only header for previous date -->
                    {{ form.get('headers.previousValue')?.value | dateLocale }}
                </th>
                <th class="hamMenuCol">&nbsp;</th>
            </tr>
        </thead>

        <!-- Data Rows -->
        <tbody formArrayName="dataSource">
            <tr *ngFor="let row of form.get('dataSource')?.controls; let i = index" [formGroupName]="i">
                <td class="hamScaleCol" style="min-width: 400px">
                    <input hamInput type="text" formControlName="text" />
                </td>
                <td
                    class="hamNumberCol300 currentYear"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.currentValue === '' ||
                                row?.value?.currentValue === '-' ||
                                row?.value?.currentValue === 0 ||
                                row?.value?.currentValue == null)
                    }"
                >
                    <input hamInput type="number" formControlName="currentValue" />
                </td>
                <td
                    class="hamNumberCol300 previousYear"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.previousValue === '' ||
                                row?.value?.previousValue === '-' ||
                                row?.value?.previousValue === 0 ||
                                row?.value?.previousValue == null)
                    }"
                >
                    <input hamInput type="number" formControlName="previousValue" />
                </td>
                <td class="hamMenuCol">
                    <span
                        hamIconShapes
                        icon="assets/hamIcons/minus-outline.svg"
                        [variant]="'transparent'"
                        [size]="'menu'"
                        [type]="'circle'"
                        (click)="removeRow(i)"
                    ></span>
                </td>
            </tr>
        </tbody>

        <!-- Total Row: Only display if the total row control exists -->
        <tfoot *ngIf="displayTotalRow">
            <tr [formGroup]="form.get('totalRow')">
                <td class="hamScaleCol" style="min-width: 400px">
                    <!-- Editable total label -->
                    <input hamInput type="text" formControlName="text" placeholder="Total Label" />
                </td>
                <td class="hamNumberCol300 currentYear">
                    <input hamInput type="number" formControlName="currentValue" [readonly]="true" />
                </td>
                <td class="hamNumberCol300 previousYear">
                    <input hamInput type="number" formControlName="previousValue" [readonly]="true" />
                </td>
                <td class="hamMenuCol">&nbsp;</td>
            </tr>
        </tfoot>
    </table>

    <!-- Preview Mode Table: viewMode <= 1 -->
    <table class="ham-table previewMode" *ngIf="viewMode <= 1">
        <!-- Header Row -->
        <thead>
            <tr>
                <th class="hamScaleCol" style="min-width: 400px">
                    <!-- ham-referencing-input-component in Preview Mode -->
                    <ham-referencing-input-component
                        class="referencing-input"
                        [isEditMode]="false"
                        [title]="form.get('headers.text')?.value"
                        [isReferenced]="addReferencing"
                        [isNumbered]="addNumbering"
                        [numbering]="tableNumber"
                        [width]="'400px'"
                        (titleChange)="onTitleChanged($event)"
                        (addNumbering)="onAddNumberToggleChange($event)"
                        (addReferencing)="openReferenceDialog()"
                    ></ham-referencing-input-component>
                </th>
                <th class="hamNumberCol300 currentYear">
                    <span>{{ form.get('headers.currentValue')?.value | dateLocale }}</span>
                </th>
                <th class="hamNumberCol300 previousYear">
                    <span>{{ form.get('headers.previousValue')?.value | dateLocale }}</span>
                </th>
            </tr>
        </thead>

        <!-- Data Rows -->
        <tbody>
            <tr *ngFor="let row of form.get('dataSource')?.controls; let i = index">
                <td class="hamScaleCol" style="min-width: 400px">
                    <span>{{ row.value.text }}</span>
                </td>
                <td
                    class="hamNumberCol300 currentYear"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.currentValue === '' ||
                                row?.value?.currentValue === '-' ||
                                row?.value?.currentValue === 0 ||
                                row?.value?.currentValue == null)
                    }"
                >
                    <span>{{ row.value.currentValue | finNumber }}</span>
                </td>
                <td
                    class="hamNumberCol300 previousYear"
                    [ngClass]="{
                        todoHighlight:
                            highlightTodos &&
                            (row?.value?.previousValue === '' ||
                                row?.value?.previousValue === '-' ||
                                row?.value?.previousValue === 0 ||
                                row?.value?.previousValue == null)
                    }"
                >
                    <span>{{ row.value.previousValue | finNumber }}</span>
                </td>
            </tr>
        </tbody>

        <!-- Total Row: Only display if the total row control exists -->
        <tfoot *ngIf="displayTotalRow">
            <tr [formGroup]="form.get('totalRow')">
                <td class="hamScaleCol" style="min-width: 400px">
                    <span>{{ form.get('totalRow.text')?.value }}</span>
                </td>
                <td class="hamNumberCol300 currentYear">
                    <span>{{ form.get('totalRow.currentValue')?.value | finNumber }}</span>
                </td>
                <td class="hamNumberCol300 previousYear">
                    <span>{{ form.get('totalRow.previousValue')?.value | finNumber }}</span>
                </td>
            </tr>
        </tfoot>
    </table>

    <ham-button
        variant="primary"
        icon="assets/hamIcons/circle-plus.svg"
        [outline]="true"
        style="display: inline-block"
        (buttonClick)="addItem()"
    >
        {{ 'aumico_notes_add_more_row' | i18next }}
    </ham-button>

    <!-- Footnote Section -->
    <div class="footnote-section" *ngIf="hasFootnotes && viewMode >= 2">
        <label for="footnote">{{ 'aumico_notes_footnote_label' | i18next }}</label>
        <textarea
            hamInput
            [hideRemoveXButton]="true"
            id="footnote"
            formControlName="footnote"
            [placeholder]="'aumico_notes_footnote_placeholder' | i18next"
        ></textarea>
    </div>
</form>
